(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    const swaddleHandle = 'personalized-baby-name-swaddle-blanket';
  let swaddlePersonalizationName = '';

  const showAssignedColorMedia = (input) => {
    const mediaId = input.dataset.assignedColorMediaId;
    if (!mediaId) return;

    const section = input.closest('.shopify-section');
    const gallery = section?.querySelector('media-gallery');
    const slideshowTarget = gallery?.querySelector(`slideshow-slide[data-media-id="${mediaId}"]`);
    if (!gallery) return;

    if (gallery.dataset.presentation === 'grid') {
      const gridTarget = gallery.querySelector(`.media-gallery__grid > [data-media-id="${mediaId}"]`);
      if (!gridTarget) return;

      const moveToFirst = () => {
        gridTarget.parentElement?.prepend(gridTarget);
        slideshowTarget?.parentElement?.prepend(slideshowTarget);
      };
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (document.startViewTransition && !reduceMotion) {
        document.startViewTransition(moveToFirst);
      } else {
        moveToFirst();
      }
      return;
    }

    if (!slideshowTarget) return;

    const slides = Array.from(gallery.querySelectorAll('slideshow-slide[data-media-id]'));
    const index = slides.indexOf(slideshowTarget);
    if (index >= 0) gallery.slideshow?.select(index, undefined, { animate: true });
  };

  const setSwaddlePurchaseDisabled = (picker, disabled) => {
    const section = picker.closest('.shopify-section');
    if (!section) return;

    section
      .querySelectorAll('[ref="addToCartButton"], .shopify-payment-button__button')
      .forEach((button) => {
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });
  };

  const syncSwaddlePersonalization = (picker) => {
    const nameInput = picker.querySelector('[data-swaddle-personalization-name]');
    if (!nameInput) return;

    const value = nameInput.value.trim();
    const counter = picker.querySelector('[data-swaddle-name-count]');
    const characterCount = String(nameInput.value.length);
    if (counter && counter.textContent !== characterCount) counter.textContent = characterCount;

    const section = picker.closest('.shopify-section');
    section?.querySelectorAll('product-form-component form').forEach((form) => {
      let propertyInput = form.querySelector('[data-swaddle-name-property]');
      if (!propertyInput) {
        propertyInput = document.createElement('input');
        propertyInput.type = 'hidden';
        propertyInput.name = 'properties[Baby name]';
        propertyInput.dataset.swaddleNameProperty = '';
        form.append(propertyInput);
      }
      propertyInput.value = value;
    });

    const hasColor = Boolean(picker.querySelector('input[data-option-name="Color"]:checked'));
    setSwaddlePurchaseDisabled(picker, !hasColor || value.length === 0);
  };

  const prepareSwaddlePicker = (picker, resetCustomerChoices = false) => {
    picker.querySelectorAll('fieldset').forEach((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
      if (fieldset.hasAttribute('data-auto-select-option')) {
        const preferred = inputs.find((input) => input.value === 'Block+Script') || inputs[0];
        if (preferred) {
          preferred.checked = true;
          preferred.dataset.currentChecked = 'true';
        }
        return;
      }

      if (resetCustomerChoices) {
        inputs.forEach((input) => {
          input.checked = false;
          input.dataset.currentChecked = 'false';
          input.dataset.previousChecked = 'false';
        });
      }
    });

    const nameInput = picker.querySelector('[data-swaddle-personalization-name]');
    if (nameInput && nameInput.value !== swaddlePersonalizationName) {
      nameInput.value = swaddlePersonalizationName;
    }
    syncSwaddlePersonalization(picker);
  };

  const resetSwaddleOptions = () => {
    if (new URL(window.location.href).searchParams.has('variant')) return;

    const selector = `variant-picker[data-product-handle="${swaddleHandle}"][data-template-product-match="true"]`;
    document.querySelectorAll(selector).forEach((picker) => {
      picker.querySelectorAll('.variant-option__swatch-value').forEach((value) => {
        value.textContent = '';
      });
      prepareSwaddlePicker(picker, true);
    });
  };

  document.addEventListener('input', (event) => {
    if (!(event.target instanceof Element)) return;
    const nameInput = event.target.closest('[data-swaddle-personalization-name]');
    if (!nameInput) return;

    const picker = nameInput.closest('variant-picker');
    if (!picker) return;

    swaddlePersonalizationName = nameInput.value;
    syncSwaddlePersonalization(picker);
  });

  document.addEventListener(
    'change',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const selector = `variant-picker[data-product-handle="${swaddleHandle}"] input[type="radio"]`;
      const input = event.target.closest(selector);
      if (!input) return;

      const picker = input.closest('variant-picker');
      if (!picker) return;

      showAssignedColorMedia(input);

      const requiredOptionCount = picker.querySelectorAll('fieldset').length;
      const selectedOptionNames = new Set(
        Array.from(picker.querySelectorAll('fieldset input[type="radio"]:checked')).map(
          (selectedInput) => selectedInput.dataset.optionName
        )
      );

      if (selectedOptionNames.size < requiredOptionCount) {
        event.stopImmediatePropagation();
        setSwaddlePurchaseDisabled(picker, true);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetSwaddleOptions, { once: true });
  } else {
    resetSwaddleOptions();
  }

  const swaddlePickerObserver = new MutationObserver(() => {
    const selector = `variant-picker[data-product-handle="${swaddleHandle}"][data-template-product-match="true"]`;
    document.querySelectorAll(selector).forEach((picker) => prepareSwaddlePicker(picker));
  });
  swaddlePickerObserver.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
